import { PermissionRules, PERMISSIONS } from '@teamworksdev/influencer/core';

const hasTeamManagementRead = PermissionRules.hasTeamPermission(PERMISSIONS.TEAM_ADMIN);

const accessRoster = hasTeamManagementRead;

export {
	accessRoster,
};
